import { a as t } from "./useIsWithDevices-CoLsTYPw.js";
function c({ children: i, devices: e }) {
  return t(e) ? null : i;
}
export {
  c as WithoutDevices
};
